import { render, staticRenderFns } from "./usercenter-hr.vue?vue&type=template&id=1681a90a&scoped=true&"
import script from "./usercenter-hr.vue?vue&type=script&lang=js&"
export * from "./usercenter-hr.vue?vue&type=script&lang=js&"
import style0 from "./usercenter-hr.vue?vue&type=style&index=0&id=1681a90a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1681a90a",
  null
  
)

export default component.exports